import { ChangeOrder, Job, Note, ConstructionStatusName } from '.';

export class ChangeOrderGroup {
    id: number;
    sequence: number;
    jobId: number;
    job: Job;
    hasJio: boolean;
    hasSchedule: boolean;
    noteId: number;
    jobChangeOrderGroupDescription: string;
    constructionRejectReason: string = "";
    salesStatusDescription: string;
    salesStatusUTCDate?: Date;
    constructionStatusDescription: ConstructionStatusName;
    constructionStatusUTCDate: Date;
    constructionStatusLastModifiedBy: string;
    createdBy: string;
    createdUtcDate: Date;
    lastModifiedBy: string;
    lastModifiedUtcDate: Date;
    changeOrders: ChangeOrder[];
    note: Note;
}